import { PureComponent } from 'react';
import { message } from 'antd';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

class ConnectionStatusTracker extends PureComponent {
  messageKey = 'ConnectionStatusTracker';

  componentDidMount() {
    window.addEventListener('online', this._handleOnlineState);
    window.addEventListener('offline', this._handleOfflineState);
  }

  componentWillUnmount() {
    window.removeEventListener('online', this._handleOnlineState);
    window.removeEventListener('offline', this._handleOfflineState);
  }

  _handleOnlineState = () => {
    // TODO: analytikav2 event needed
    message.success({
      content: this.props.t('general.internetConnected'),
      duration: 5,
      key: this.messageKey
    });
  };

  _handleOfflineState = () => {
    // TODO: analytikav2 event needed
    message.loading({
      content: this.props.t('general.internetDisconnected'),
      duration: 0,
      key: this.messageKey
    });
  };

  render() {
    return null;
  }
}

ConnectionStatusTracker.propTypes = {
  t: PropTypes.func
};

export default withTranslation()(ConnectionStatusTracker);
